import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {
        orderNew: {
            apiPath: '',
            properties: {},
            filters: {},
        },
    },
    components: {
        orderNewView: {
            component: 'Card',
            entity: 'orderNew',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    { component: 'orderNewBtns' },
                    { component: 'CancelOrder' },
                    // { component: 'couponVerificationBtn' },
                ],
            },
        },

        orderNewBtns: {
            component: 'GridLayout',
            direction: 'horizontal',
            style: { marginBottom: 16 },
            align: 'start',
            items: [
                {
                    component: 'Button',
                    text: '线上下单线下付款补单',
                    type: 'primary',
                    span: 3,
                    route: '/trade/orderSupplement',
                },
            ],
        },

        couponVerificationBtn: {
            component: 'GridLayout',
            direction: 'horizontal',
            style: { marginTop: 16 },
            align: 'start',
            items: [
                {
                    component: 'Button',
                    text: '优惠券核销',
                    type: 'primary',
                    span: 3,
                    route: '/trade/orderSupplement',
                },
            ],
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/trade',
                    breadcrumbName: '',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/orderNew',
                            component: 'orderNewView',
                            breadcrumbName: '新销售订单管理',
                        },
                        {
                            path: '/orderSupplement',
                            component: 'OrderSupplementView',
                            breadcrumbName: '线上下单线下付款补单',
                        },
                    ],
                },
            ],
        },
    ],
};
